/**
 * 月別レポート機能の設定定数
 */

/**
 * レポート対象学校の設定
 * - key: 学校ID
 * - firstMonth: レポート出力可能な最初の対象月（YYYY-MM形式）
 *
 * 学校を追加する場合はここにエントリを追加する
 */
export const REPORT_SCHOOLS = {
  13: { firstMonth: '2026-04' }, // テストさくら高等学校
  14: { firstMonth: '2026-04' }, // N高・S高・R高
  29: { firstMonth: '2026-04' }, // ZEN大学
};

/**
 * レポート機能が有効な学校IDリスト（REPORT_SCHOOLS から自動生成）
 * アナリティクスタブの表示対象でもある
 */
export const REPORT_SCHOOL_IDS = Object.keys(REPORT_SCHOOLS).map(Number);

/**
 * 月別レポート機能の全体公開日時（JST）
 * production / demo 環境では学校別 firstMonth に関わらず、この日時より前は
 * 月別レポートのダウンロード欄全体を非表示にする
 */
export const REPORT_FEATURE_RELEASE_AT = '2026-05-12T13:00:00+09:00';

/**
 * 学校のレポート公開日を取得（firstMonth の翌月1日）
 * 例: firstMonth '2026-04' → 公開日 '2026-05-01'
 * @param {number} schoolId
 * @returns {string|null} YYYY-MM-DD 形式、未登録学校は null
 */
export const getReportReleaseDate = (schoolId) => {
  const config = REPORT_SCHOOLS[schoolId];
  if (!config) return null;
  const [year, month] = config.firstMonth.split('-').map(Number);
  const nextMonth = month === 12 ? `${year + 1}-01-01` : `${year}-${String(month + 1).padStart(2, '0')}-01`;
  return nextMonth;
};
